import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-donation-card',
  templateUrl: './donation-card.component.html',
  styleUrls: ['./donation-card.component.scss'],
})
export class DonationCardComponent implements OnInit {
  @Input() details: any;
  @Input() donation: any;
  @Output() clickDetails = new EventEmitter<any>();
  constructor() { }

  ngOnInit() { 
    console.log(this.donation);
  }

  getImage() {
    if (this.donation.urls && this.donation.urls.length > 0 && this.donation.urls[0]) {
      return this.donation.urls[0]
    } else {
      // return './assets/imgs/event.png';
      return './assets/imgs/donation.png';
    }
  }

  viewFeedDetails() {
    this.clickDetails.emit(this.donation.id);
  }
}
